// dependencies
import {
    collection,
    getDocs,
    doc,
    getDoc,
    addDoc,
    updateDoc,
    deleteDoc,
    where,
    query,
    orderBy,
    limit,
} from "firebase/firestore";
import { db } from "./firebaseConfig";
import { deleteObject, listAll, ref } from "firebase/storage";



const projectsCollection = collection(db, 'projects');


// === READ === //
// get all projects
export const getAllProjects = async () => {
    const snapshot = await getDocs(projectsCollection);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// get top 3 projects
export const getTop3Projects = async () => {
    const projectsQuery = query(
        projectsCollection,
        where("favourited", "==", true),
        orderBy("createdAt", "desc"),
        limit(3)
    );

    const snapshot = await getDocs(projectsQuery);

    const topProjects = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }));

    //console.log(topProjects);
    return topProjects;
};

// get single project
export const getProjectById = async (id) => {
    const docRef = doc(db, 'projects', id);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
};
// ================ //



// === CREATE === //
/**
 * add a document to a collection
 * @param {string} collectionName name of the firestore collection
 * @param {Object} data object with the data to be added
 * @returns {string} the added document id
 */
export const addDocument = async (collectionName, data) => {
    try {
        const docRef = await addDoc(collection(db, collectionName), data);
        return docRef.id;
    } catch (error) {
        console.error("adding document error:", error.message);
        throw error;
    } 
};



// === UPDATE === //
/**
 * update a document in a collection
 * @param {string} collectionName name of the firestore collection
 * @param {string} id ID of the document to be updated
 * @param {Object} data object with the data to be updated
 * @returns {Promise<Object>} the updated document
 */
export const updateDocument = async (collectionName, id, data) => {
    try {
        return await updateDoc(doc(db, collectionName, id), data);
    } catch (error) {
        console.error("updating document error:", error.message);
        throw error;
    }
};
// ================ //




// === DELETE === //
/**
 * delete a document from a collection
 * @param {string} collectionName name of the firestore collection
 * @param {string} id id of the document to be deleted
 * @returns {Promise<void>} the deleted document
 */
export const deleteDocument = async (collectionName, id) => {
    try {
        return await deleteDoc(doc(db, collectionName, id));
    } catch (error) {
        console.error("deleting document error:", error.message);
        throw error;
    }
};


/**
 * recursively deletes all files in a folder
 * @param {object} storage - firebase storage instance
 * @param {string} folderPath - path to the folder to delete
 * @returns {Promise<void>}
 */
export const deleteFolder = async (storage, folderPath) => {
  try {
    const folderRef = ref(storage, folderPath);
    const listResult = await listAll(folderRef);

    // delete all files in current folder
    await Promise.all(listResult.items.map((item) => deleteObject(item)));

    // recursively delete all subfolders
    await Promise.all(
        listResult.prefixes.map((folder) => deleteFolder(storage, folder.fullPath))
    );

    } catch (error) {
        console.error("Deleting folder error:", error.message);
        throw error;
    }
}
// ================ //

